// src/services/api.js
import axios from "axios";
import { io } from "socket.io-client";

const API_URL =
  process.env.REACT_APP_API_URL || "https://backend.40minchbingo.com/bingo-api";
const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "https://backend.40minchbingo.com";

// 🧩 Axios instance
export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔗 Socket.IO connection
export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  reconnection: true,
});

// Log socket status for debugging
socket.on("connect", () => {
  //  console.log("🟢 Connected to Socket.IO:", socket.id);
});
socket.on("disconnect", (reason) => {
  console.warn("🔴 Disconnected:", reason);
});
socket.on("connect_error", (err) => {
  console.error("⚠️ Socket connection error:", err.message);
});
